import { useState } from "react";
import { NumericFormat } from "react-number-format";
import { toast } from "react-toastify";
import { Button, Modal, ModalBody } from "reactstrap";
import { POST } from "../../../helper/api";

const UpsertPITFeeComponent = ({
  onCancel,
  onSuccess,
  data
}) => {
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState(data?.amount || 0);
  const upsertData = () => {
    setLoading(true);
    POST(`employee/pay-in-out/upsert-pit-fee`, {
      type: 'OUT',
      category: 'PIT_FEE',
      userId: data?.user?.id,
      amount,
      date: data?.date,
    }, {}, true)
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch(({ response }) => {
        toast.error(response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại.");
      })
      .finally(() => {
        setLoading(false);
      });
  }
  return <Modal isOpen={true} toggle={onCancel}>
    <ModalBody className="modal-body-lg text-center">
      <div className="nk-modal">

        <h4 className="nk-modal-title">
          Sửa tiền thuế PIT nhân viên {data?.user?.name}
        </h4>
        <div className="nk-modal-body">
          <NumericFormat
            className="form-control"
            type="text"
            value={amount}
            thousandsGroupStyle="thousand"
            thousandSeparator=","
            decimalScale={0}
            onValueChange={(val) => setAmount(val.floatValue)}
          />
        </div>
        <div className="nk-modal-action mt-5 d-flex justify-content-around">
          <Button
            disabled={loading}
            color="light"
            size="lg"
            className="btn-mw mr-5"
            onClick={onCancel}
          >
            Huỷ bỏ
          </Button>
          <Button
            disabled={loading}
            color="primary"
            size="lg"
            className="btn-mw"
            onClick={(ev) => {
              ev.preventDefault();
              upsertData();
            }}
          >
            Xác nhận
          </Button>
        </div>
      </div>
    </ModalBody>
  </Modal>
}

export default UpsertPITFeeComponent;